import { toast } from 'react-toastify';
import CheckOutlined from '@mui/icons-material/CheckOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import QRCode from 'react-qr-code';
import { toPng } from 'html-to-image';

interface Props {
    label?: string;
    text: string;
}

export default function RenderQRCodeAndCopyButton({ label, text }: Props) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const qrRef = useRef<any>();
    const [buttonLabel, setButtonLabel] = useState(label || text);

    const onCopy = () => {
        setButtonLabel('Copied!');
        const svg = qrRef.current?.querySelector('svg');
        if (svg) {
            toPng(svg)
                .then((dataUrl) => {
                    fetch(dataUrl)
                        .then((res) => res.blob())
                        .then((blob) => {
                            const item = new ClipboardItem({ 'image/png': blob });
                            navigator.clipboard.write([item]);
                        });
                })
                .catch((err) => {
                    console.error('Failed to copy QR code', err);
                });
        }

        const timer = setTimeout(() => {
            setButtonLabel(label || text);
        }, 2000);

        return () => clearTimeout(timer);
    };

    return (
        <>
            <div
                ref={qrRef}
                style={{ height: 'auto', margin: '0 auto', maxWidth: 250, width: '100%' }}
            >
                <QRCode
                    size={256}
                    style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                    value={text}
                    viewBox={`0 0 256 256`}
                />
            </div>
            <Typography paddingTop={4} paddingBottom={2} textAlign={'center'} variant="h5">
                OR
            </Typography>
            <Button
                endIcon={buttonLabel === 'Copied!' ? <CheckOutlined /> : <ContentCopyIcon />}
                onClick={(e) => {
                    navigator.clipboard.writeText(text);
                    e.preventDefault();
                    e.stopPropagation();
                    toast.info(`QR code copied!`);
                    onCopy();
                }}
                // variant="outlined"
                style={{ color: 'rgba(0, 0, 0, 0.87)' }}
                sx={{ textTransform: 'none' }}
            >
                <Typography>{buttonLabel}</Typography>
            </Button>
        </>
    );
}
